import React from 'react';
import { PiTextT, PiCode } from 'react-icons/pi';

interface TogglePlainTextButtonProps {
  isPlainTextMode: boolean;
  onToggle: () => void;
}

const TogglePlainTextButton: React.FC<TogglePlainTextButtonProps> = ({
  isPlainTextMode,
  onToggle
}) => (
  <button
    type="button"
    onClick={onToggle}
    className={`p-2 rounded transition-colors ${
      isPlainTextMode 
        ? 'bg-gray-200 dark:bg-gray-700 text-gray-900 dark:text-gray-100' 
        : 'hover:bg-gray-100 dark:hover:bg-gray-800 text-gray-600 dark:text-gray-400'
    }`}
    title={isPlainTextMode ? 'Switch to Rich Text Editor' : 'Switch to Plain Text Editor'}
    aria-label={isPlainTextMode ? 'Switch to Rich Text Editor' : 'Switch to Plain Text Editor'}
  >
    {isPlainTextMode ? <PiCode size={18} /> : <PiTextT size={18} />}
  </button>
);

export default TogglePlainTextButton;
